var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',[_vm._t("header")],2),_c('form',[_c('label',[_vm._v(" "+_vm._s(_vm.label)+" "),_c('text-reader',{attrs:{"label":_vm.buttonLabel},on:{"load":_vm.readText}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }